import { useBaseIndex } from 'components/commercetools-ui/organisms/product/product-list-ssr/local-store';
import { useFormat } from 'helpers/hooks/useFormat';
import SortFacet from '../facets/sort';

const DesktopSortFacets = () => {
  const productsIndex = useBaseIndex();

  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  const sortValues = [
    {
      label: formatProductMessage({ id: 'new-products', defaultMessage: 'New' }),
      value: productsIndex,
    },
    {
        label: formatProductMessage({ id: 'nameAsc', defaultMessage: 'Name A-Z' }),
        value: productsIndex.replace('-main', '') + '_name_asc',
    },
    {
        label: formatProductMessage({ id: 'nameDsc', defaultMessage: 'Name Z-A' }),
        value: productsIndex.replace('-main', '') + '_name_desc',
    },
  ]

  return (
      <div className="border border-[#2B2C39] hover:cursor-pointer">
      <SortFacet items={sortValues}/>
      </div>
  );
};

export default DesktopSortFacets;
